package app.bloomey.web.modules.analytics

import app.bloomey.web.core.data.models.Precision
import app.bloomey.web.core.data.models.TimeSeriesQuery
import com.copperleaf.ballast.InputHandler
import com.copperleaf.ballast.InputHandlerScope
import kotlinx.coroutines.flow.collectLatest

class AnalyticsInputHandler : InputHandler<
        AnalyticsContract.Inputs,
        AnalyticsContract.Events,
        AnalyticsContract.State> {

    private val repository = AnalyticsRepository()
    override suspend fun InputHandlerScope<
            AnalyticsContract.Inputs,
            AnalyticsContract.Events,
            AnalyticsContract.State>.handleInput(
        input: AnalyticsContract.Inputs,
    ): Unit = when (input) {
        is AnalyticsContract.Inputs.GetTotalUsers -> {
            repository.totalUsers(TimeSeriesQuery(precision = Precision.month, 2)).collectLatest { state ->
                updateState {
                    it.copy(totalUsers = state)
                }
            }
        }

        AnalyticsContract.Inputs.MonthlyActiveUsers -> {
            repository.activeUsers(TimeSeriesQuery(precision = Precision.month, 2)).collectLatest { state ->
                updateState {
                    it.copy(monthlyActiveUsers = state)
                }
            }
        }

        AnalyticsContract.Inputs.DailyActiveUsers -> {
            repository.activeUsers(TimeSeriesQuery(precision = Precision.day, 6)).collectLatest { state ->
                updateState {
                    it.copy(dailyActiveUsers = state)
                }
            }
        }

        AnalyticsContract.Inputs.NewUsers -> {
            repository.newUsers(TimeSeriesQuery(precision = Precision.day, 6)).collectLatest { state ->
                updateState {
                    it.copy(newUsers = state)
                }
            }
        }
    }
}
